import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, setToken, setUser, type User } from "../api";

export default function Register({ onAuth }: { onAuth: (u: User) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (password.length < 8) { setErr("密碼至少 8 碼"); return; }
    setBusy(true);
    try {
      const { token, user } = await api.register(email, password);
      setToken(token);
      setUser(user);
      onAuth(user);
      window.dispatchEvent(new Event("gd-auth-changed"));
      navigate("/", { replace: true });
    } catch (e: any) {
      setErr(e.message || "註冊失敗");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="card" onSubmit={submit}>
        <h1>建立 GD HUB 帳號</h1>
        <div className="muted" style={{ marginBottom: 16 }}>開始管理你的 LINE Webhook 中繼</div>
        {err && <div className="error">{err}</div>}
        <div className="field">
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </div>
        <div className="field">
          <label>密碼（至少 8 碼）</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
        </div>
        <button className="primary" type="submit" disabled={busy} style={{ width: "100%" }}>
          {busy ? "建立中…" : "註冊"}
        </button>
        <div style={{ textAlign: "center", marginTop: 14, fontSize: 13 }}>
          已有帳號？ <Link to="/login">登入</Link>
        </div>
      </form>
    </div>
  );
}
